const defaultTerminiatedCommandExtractor = {
    allowEmptyCommands: false,
    terminators: ['\r', '\n'],
};
export class CommandBuffer {
    constructor(commandExtractor) {
        this.buffer = '';
        this.commands = [];
        this.terminatedCommandExtractor = Object.assign({}, defaultTerminiatedCommandExtractor);
        if (typeof commandExtractor === 'function') {
            this.extractCommand = commandExtractor;
        }
        else {
            if (commandExtractor !== undefined) {
                this.terminatedCommandExtractor = Object.assign(Object.assign({}, this.terminatedCommandExtractor), commandExtractor);
            }
            this.extractCommand = this.extractTerminatedCommand;
        }
    }
    add(data) {
        this.buffer += data;
        let res = this.extractCommand(this.buffer);
        while (res !== undefined) {
            if (res.command !== undefined)
                this.commands.unshift(res.command);
            this.buffer = res.buffer;
            res = this.extractCommand(this.buffer);
        }
    }
    clear() {
        this.buffer = '';
        this.commands.length = 0;
    }
    getCommand() {
        return this.commands.pop();
    }
    extractTerminatedCommand(buffer) {
        let command = '';
        for (let i = 0; i < buffer.length; i++) {
            const c = this.buffer.charAt(i);
            if (this.terminatedCommandExtractor.terminators.includes(c)) {
                if (command.length > 0 || this.terminatedCommandExtractor.allowEmptyCommands) {
                    const res = {
                        command,
                        buffer: buffer.slice(i + 1),
                    };
                    return res;
                }
            }
            else {
                command += c;
            }
        }
        if (this.terminatedCommandExtractor.unterminatedRegExp) {
            const match = this.terminatedCommandExtractor.unterminatedRegExp.exec(command);
            if (match !== null && match[0].length > 0) {
                const res = {
                    command: match[0],
                    buffer: buffer.slice(0, match.index) + buffer.slice(match.index + match[0].length),
                };
                return res;
            }
        }
        return undefined;
    }
    hasCommands() {
        return this.commands.length > 0;
    }
    setUnterminatedRegExp(regExp) {
        const prev = this.terminatedCommandExtractor.unterminatedRegExp;
        this.terminatedCommandExtractor.unterminatedRegExp = regExp;
        return prev;
    }
}
